module.exports = __webpack_public_path__ + "static/media/Logo.c0aa4f2d.png";